export enum TypeEnvoi {
  // ── Urbain ──────────────────────────────────
  EXPRESS_URBAIN      = 'Express urbain',
  STANDARD_URBAIN     = 'Standard urbain',
  // ── Interurbain ─────────────────────────────
  EXPRESS_INTERURBAIN   = 'Express interurbain',
  STANDARD_INTERURBAIN  = 'Standard interurbain',
}

export const TYPE_ENVOI_URBAIN: (keyof typeof TypeEnvoi)[] = [
  'EXPRESS_URBAIN', 'STANDARD_URBAIN'
];

export const TYPE_ENVOI_INTERURBAIN: (keyof typeof TypeEnvoi)[] = [
  'EXPRESS_INTERURBAIN', 'STANDARD_INTERURBAIN'
];
